var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOne01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.398 172.16 16 16",
    enableBackground: "new 78.398 172.16 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M86.398,172.16c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S90.809,172.16,86.398,172.16z  M86.398,187.16c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S90.257,187.16,86.398,187.16z M87.263,175.367 c-0.186-0.078-0.396-0.042-0.541,0.095l-2.143,2.008c-0.201,0.188-0.212,0.505-0.023,0.706c0.19,0.203,0.506,0.213,0.707,0.023 l1.301-1.219v7.013c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-8.167C87.564,175.627,87.446,175.447,87.263,175.367z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOne01);
export default __webpack_public_path__ + "static/media/icon_one-01.fb2babf28c594482dbcac95aae625f85.svg";
export { ForwardRef as ReactComponent };